export default __webpack_public_path__ + "static/icp-ent-logo-02d0006cb2204908409e4ebe194be426.png";